import { motion } from "framer-motion"
import { EFonts } from "libs/style/styling"
import { AnimTap, EColors } from "libs/style/w24_styling"
import React from "react"
import styled, { css } from "styled-components/macro"

interface Props {
  title: string
  choiceItem?: "fill" | "border"
  link?: string
  target?: string
  className?: string
  onClick?: () => void
}

export const LinkItem = (props: Props): JSX.Element => {
  const selected = props.choiceItem === "fill"

  return (
    <S_LinkItem
      className={props.className}
      $selected={selected}
      {...AnimTap}
      href={props.link}
      target={props.target}
      onClick={props.onClick}
    >
      {props.choiceItem === "fill" && <S_Circle $fill={true} />}
      {props.choiceItem === "border" && <S_Circle />}
      <S_Text $selected={selected}>{props.title}</S_Text>
    </S_LinkItem>
  )
}

const S_LinkItem = styled(motion.a)`
  cursor: pointer;
  display: inline-flex;
  gap: 15px;
  align-items: center;
  ${props => {
    if (props.$selected) {
      return css``
    } else {
      return css`
        &:hover {
          ${S_Text} {
            text-decoration: none;
          }
          ${S_Circle} {
            background-color: ${EColors.DARK};
            border: unset;
          }
        }
      `
    }
  }}
`

const S_Text = styled.span<{ $selected: boolean }>`
  font-family: ${EFonts.Medium};
  color: ${EColors.DARK};
  font-size: 15px;
  text-decoration: underline;
  user-select: none;
  ${props => {
    if (props.$selected) {
      return css`
        font-family: ${EFonts.Bold};
        text-decoration: none;
      `
    } else {
      return css``
    }
  }}
  @media only screen and (min-width: 1260px) {
    font-size: 18px;
  }
`

const S_Circle = styled.div<{ $fill: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  ${props => {
    if (props.$fill) {
      return css`
        background-color: ${EColors.DARK};
      `
    } else {
      return css`
        border: 2px solid ${EColors.DARK};
      `
    }
  }}
`
